import styled from "styled-components";

export const TEMP_IMAGE_URL = "/assets/images/temp_image.png";

export function EmptyImagePlaceholder() {
  return <Image src={TEMP_IMAGE_URL} alt="" draggable={false} />;
}

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
